import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import App from './App';
import TokenProviderSetup from './components/TokenProviderSetup';
import { logger } from './utils/logger';
import './index.css';

logger.setupGlobalHandlers();

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

if (!domain || !clientId) {
  throw new Error('Missing required Auth0 environment variables: VITE_AUTH0_DOMAIN, VITE_AUTH0_CLIENT_ID');
}

const rootElement = document.getElementById('root');
// index.html に必ず存在するが、`!`（AGENTS.md 3 で禁止）を使わずに明示的に落とす。
// 取り違えたときに「画面が真っ白」ではなく原因の分かる例外になる。
if (!rootElement) {
  throw new Error('#root が見つかりません（index.html を確認してください）');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: audience || undefined,
        scope: 'openid profile email offline_access',
      }}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      <BrowserRouter>
        <TokenProviderSetup />
        <App />
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>
);
